import { useCallback, useMemo, useState } from "react";
import BatchesService from "../../../services/processing/batches";
import { useSaveDownloaded } from "../../../lib/hooks/useSaveDownloaded";

export const useExportCheckPayments = (request: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const checkPaymentsRequest = useMemo(
    () => ({
      dateTo: request?.to,
      dateFrom: request?.from,
    }),
    [request]
  );

  const { save } = useSaveDownloaded(
    "check-payments.csv",
    "text/csv;charset=utf-8",
    setIsLoading
  );

  const onExportCheck = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await BatchesService.exportChecks(checkPaymentsRequest);

      save(res);
    } catch {
      setIsLoading(false);
    }
  }, [checkPaymentsRequest, save]);

  return { onExportCheck, isLoading };
};
